import React, { useState, useCallback, useEffect } from "react";
import { Form } from "semantic-ui-react";
import { producaov2 as api } from "../../../../../services/apis";

import swal from "sweetalert";
import { StyledLabel, StyledButton } from "./styles";
import AlunoSearchInputMultiple from "../../../AlunoSearchInputMultiple";
import CursoSearchInputMultiple from "../../../CursoSearchInputMultiple";
import { useRouter } from "../../../../../hooks/router";
import Loading from "../../../../Loading";

const Formulario = () => {
  const [emailList, setEmailList] = useState([]);
  const [courseList, setCourseList] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const router = useRouter();
  const [initiateValuesPessoa, setInitiateValuesPessoa] = useState([]);
  const [initiateValuesCurso, setInitiateValuesCurso] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedAlunos, setSelectedAlunos] = useState([]);
  const [selectedCursos, setSelectedCursos] = useState([]);

  useEffect(() => {
    async function getTrail() {
      const { id } = router.query;
      const data = await api.get(`/admin/incompany/v3/trails/${id}`);
      const format = data.data;
      setCourseList(format.cursos.map((elem) => elem.id));
      setEmailList(format.pessoas.map((elem) => elem.id));
      setName(data.data.trail.title);
      setDescription(data.data.trail.description);
      setInitiateValuesPessoa(format.pessoas);
      setInitiateValuesCurso(format.cursos);
      setLoading(false);
    }

    getTrail();
  }, []);

  const editTrail = useCallback(async () => {
    try {
      const payload = {
        ids_pessoa: selectedAlunos.map((aluno) => aluno.id),
        course_ids: selectedCursos.map(curso => curso.id),
        title: name,
        description,
      };
      const update = await api.put(
        `admin/incompany/v3/trails/${router.query.id}`,
        payload
      );
      swal("Trilha editada com sucesso ", "", "success");
    } catch (err) {
      console.error(err);
      swal("Erro ao fazer a solicitação", "Favor contatar TI", "error");
    }
  }, [name, description, emailList, courseList, selectedAlunos, selectedAlunos, selectedCursos]);

  const editTrails = useCallback(async () => {
    editTrail();
  }, [name, description, emailList, courseList, editTrail, selectedAlunos, selectedCursos]);

  if (loading) {
    <Loading msg="Buscando dados" />;
  }

  const handleAlunoChange = useCallback(
    (e, { options, value }) => {
      console.log({ e, options, value });
      const email = options.find((option) => option.key === value[1]);
      console.log({ email });

      setSelectedAlunos((prev) => {
        if(email) {
          return [
            ...prev,
            { id: email.key, email: email.text },
          ]
        }

        return prev;
      });
    },
    [selectedAlunos]
  );

  const handleCursoChange = useCallback(
    (e, { options, value }) => {
      const curso = options.find((option) => option.key === value[1]);

      setSelectedCursos((prev) => {
        if(curso) {
          return [
            ...prev,
            { id: curso?.key, curso: curso?.text },
          ]
        }

        return prev;
      });
    },
    [selectedCursos]
  );

  return (
    <Form>
      <Form.Field>
        <StyledLabel>Nome da trilha </StyledLabel>
        <Form.Input
          name="name"
          placeholder="Trilha de tecnologia ALLIN"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <StyledLabel>Descrição da trilha </StyledLabel>
        <Form.Input
          name="description"
          placeholder="Trilha dedicada a pessoas com forte capacidade cognitiva"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </Form.Field>
      <Form.Field>
        <CursoSearchInputMultiple
          remove={setInitiateValuesCurso}
          initiateValue={initiateValuesCurso}
          handleChange={handleCursoChange}
          selectedCursos={selectedCursos}
          setSelectedCursos={setSelectedCursos}
        />
      </Form.Field>
      <Form.Field>
        <AlunoSearchInputMultiple
          remove={setInitiateValuesPessoa}
          initiateValue={initiateValuesPessoa}
          handleChange={handleAlunoChange}
          selectedAlunos={selectedAlunos}
          setSelectedAlunos={setSelectedAlunos}
          naoAllIn={true}
        />
      </Form.Field>
      <StyledButton onClick={editTrails}>
        <i class="plus icon"></i> Atualizar
      </StyledButton>
    </Form>
  );
};

export default Formulario;
